import inject from 'seacreature/lib/inject'
import { useContext, useEffect } from 'react'
import loading from '../material/components/loading'

const { VITE_AUTHORISATION: AUTHORISATION, VITE_API: API } = import.meta.env

inject('pod', ({ StateContext, HubContext }) => {
  inject('route', [
    '/loginfailed',
    p => () => {
      useEffect(() => {
        localStorage.removeItem('access')
        localStorage.removeItem('refresh')

        setTimeout(() => {
          window.location = '/'
        }, 5000)
      }, [])

      return <>Failed to login...returning to home screen</>
    }
  ])
})
